import { render, staticRenderFns } from "./LdGatedSwitch.vue?vue&type=template&id=50e0f822"
import script from "./LdGatedSwitch.vue?vue&type=script&lang=js"
export * from "./LdGatedSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports